module.exports = __webpack_public_path__ + "static/media/midtrans-blue.bd3908fc.svg";